import React from 'react';
import HomeOwnerErip from "../../../components/pages/grid/HomeOwnerErip/HomeOwnerErip";

const HomeOwnerEripGridPage = () => {
    return <HomeOwnerErip />
};

export default HomeOwnerEripGridPage;
